module.exports = __webpack_public_path__ + "media/images/unsplash_img-e183e1264b92d2d6654cbc7d2aa63816.jpeg";